







import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";
import { StringFilterParameter, KanaFilterParameter, InitialFilterParameter } from "../../system/filters";
import StringFilter from "../../system/filters/StringFilter.vue";
import InitialFilter from "../../system/filters/InitialFilter.vue";
import { UserFilterParameter } from ".";

@Component({
  components: {
    StringFilter,
    InitialFilter,
  },
})
export default class UserFilter extends Mixins(ModelEditableMixin) {
  editingSource: UserFilterParameter;

  @Prop({ default: false })
  isMaintenance: boolean;

  get initial(): InitialFilterParameter {
    return this.editingSource.initial;
  }

  set initial(source: InitialFilterParameter) {
    this.writeProperty(s => {
      s.initial = new InitialFilterParameter(source.keyword);
    });
  }

  get name(): StringFilterParameter {
    return this.editingSource.name;
  }

  set name(source: StringFilterParameter) {
    this.writeProperty(s => {
      s.name = source;
      s.kanaName = new KanaFilterParameter(source.keyword);
      s.initial = new InitialFilterParameter();
    });
  }

  focus(): void {
    const element = this.$refs.stringFilter as StringFilter;
    element.focus();
  }
}
